// extracted by mini-css-extract-plugin
export default {"sidebar":"styles-module--sidebar--3guV-","navItem":"styles-module--navItem--1yN6g","open":"styles-module--open--cVfIS","navSidebar":"styles-module--navSidebar--3Kzr9"};